<template>
    <vx-card title="Test Internal">
        <div class="test-internal">
            <div class="section-title">Purchase Order</div>
            <div class="button-row">
                <vs-button
                    v-for="action in poActions"
                    :key="buttonKey(action.key)"
                    :type="buttonType(action.key)"
                    color="primary"
                    class="mr-2 mb-2"
                    @click="action.handler"
                >
                    {{ action.label }}
                </vs-button>
            </div>

            <div class="section-title mt-4">Sales Order</div>
            <div class="button-row">
                <vs-button
                    v-for="action in soActions"
                    :key="buttonKey(action.key)"
                    :type="buttonType(action.key)"
                    color="primary"
                    class="mr-2 mb-2"
                    @click="action.handler"
                >
                    {{ action.label }}
                </vs-button>
            </div>

            <div v-if="selectedLabel" class="result-title mt-5">
                Result: {{ selectedLabel }}
            </div>

            <div v-if="hasResult" class="result-grid mt-3">
                <div class="result-box">
                    <div class="result-label">time_exec_function</div>
                    <div class="result-value">{{ displayValue(result.time_exec_function) }}</div>
                </div>
                <div class="result-box">
                    <div class="result-label">time_query</div>
                    <div class="result-value">{{ displayValue(result.time_query) }}</div>
                </div>
            </div>

            <div v-if="hasResult" class="mt-4">
                <div class="result-label mb-2">query</div>
                <pre class="result-pre">{{ displayValue(result.query) }}</pre>
            </div>

            <div v-if="hasResult" class="mt-4">
                <div class="result-label mb-2">data</div>
                <vs-table
                    v-if="tableHeaders.length"
                    stripe
                    border
                    :data="tableRows"
                >
                    <template slot="thead">
                        <vs-th v-for="header in tableHeaders" :key="header">
                            {{ header }}
                        </vs-th>
                    </template>

                    <template slot-scope="{ data }">
                        <vs-tr v-for="(row, index) in data" :key="index">
                            <vs-td v-for="header in tableHeaders" :key="header">
                                {{ displayValue(row[header]) }}
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <pre v-else class="result-pre">{{ dataJson }}</pre>
            </div>

            <div v-if="!hasResult" class="empty-state mt-5">
                Pilih salah satu tombol untuk menampilkan data.
            </div>
        </div>
    </vx-card>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            table: this.tableDefaultState(),
            activeAction: "",
            selectedLabel: "",
            result: this.resultDefaultState(),
        };
    },
    computed: {
        poActions() {
            return [
                {
                    key: "pool-po",
                    label: "POOL PO",
                    handler: this.getDataPoolPo,
                },
                {
                    key: "bouncer-po",
                    label: "BOUNCER PO",
                    handler: this.getDataBouncerPo,
                },
                {
                    key: "slave1-po",
                    label: "SLAVE1 PO",
                    handler: this.getDataSlave1Po,
                },
            ];
        },
        soActions() {
            return [
                {
                    key: "pool-so",
                    label: "POOL SO",
                    handler: this.getDataPoolSo,
                },
                {
                    key: "bouncer-so",
                    label: "BOUNCER SO",
                    handler: this.getDataBouncerSo,
                },
                {
                    key: "slave1-so",
                    label: "SLAVE1 SO",
                    handler: this.getDataSlave1So,
                },
            ];
        },
        hasResult() {
            return !!this.activeAction;
        },
        tableRows() {
            if (Array.isArray(this.result.data)) {
                return this.result.data;
            }

            if (this.result.data && typeof this.result.data === "object") {
                return [this.result.data];
            }

            return [];
        },
        tableHeaders() {
            if (!this.tableRows.length) {
                return [];
            }

            return this.tableRows.reduce((headers, row) => {
                if (!row || typeof row !== "object" || Array.isArray(row)) {
                    return headers;
                }

                Object.keys(row).forEach((key) => {
                    if (headers.indexOf(key) === -1) {
                        headers.push(key);
                    }
                });

                return headers;
            }, []);
        },
        dataJson() {
            return this.formatJson(this.result.data);
        },
    },
    methods: {
        tableDefaultState() {
            return {
                data: [],
            };
        },
        resultDefaultState() {
            return {
                time_exec_function: "",
                time_query: "",
                query: "",
                data: [],
            };
        },
        getData(action) {
            this.activeAction = action.key;
            this.selectedLabel = action.label;
            this.result = this.resultDefaultState();
            this.table.data = [];
            this.$vs.loading();
            this.$http
                .get(action.url)
                .then((resp) => {
                    if (resp.code == 200) {
                        this.result = this.normalizeResult(resp.data);
                        this.table.data = this.result.data;
                    }
                })
                .catch(() => {
                    this.result = this.resultDefaultState();
                    this.table.data = [];
                })
                .finally(() => {
                    this.$vs.loading.close();
                });
        },
        getDataPoolPo() {
            this.getData({
                key: "pool-po",
                label: "POOL PO",
                url: "/api/wms/v1/test-internal/pool/po",
            });
        },
        getDataBouncerPo() {
            this.getData({
                key: "bouncer-po",
                label: "BOUNCER PO",
                url: "/api/wms/v1/test-internal/bouncer/po",
            });
        },
        getDataSlave1Po() {
            this.getData({
                key: "slave1-po",
                label: "SLAVE1 PO",
                url: "/api/wms/v1/test-internal/slave1/po",
            });
        },
        getDataPoolSo() {
            this.getData({
                key: "pool-so",
                label: "POOL SO",
                url: "/api/wms/v1/test-internal/pool/so",
            });
        },
        getDataBouncerSo() {
            this.getData({
                key: "bouncer-so",
                label: "BOUNCER SO",
                url: "/api/wms/v1/test-internal/bouncer/so",
            });
        },
        getDataSlave1So() {
            this.getData({
                key: "slave1-so",
                label: "SLAVE1 SO",
                url: "/api/wms/v1/test-internal/slave1/so",
            });
        },
        normalizeResult(payload) {
            var result = this.resultDefaultState();

            if (payload && typeof payload === "object" && !Array.isArray(payload)) {
                result = Object.assign(result, payload);

                if (!Object.prototype.hasOwnProperty.call(payload, "data")) {
                    result.data = payload;
                }

                return result;
            }

            result.data = payload || [];
            return result;
        },
        buttonType(key) {
            return this.activeAction === key ? "filled" : "border";
        },
        buttonKey(key) {
            return key + "-" + this.buttonType(key);
        },
        displayValue(value) {
            if (value === null || value === undefined || value === "") {
                return "-";
            }

            if (typeof value === "object") {
                return this.formatJson(value);
            }

            return value;
        },
        formatJson(value) {
            if (value === null || value === undefined || value === "") {
                return "-";
            }

            return JSON.stringify(value, null, 2);
        },
    },
    mounted() {
    },
    watch: {},
};
</script>
<style scoped>
.test-internal {
    color: #2c2c2c;
}

.section-title {
    font-size: 14px;
    font-weight: 600;
}

.button-row {
    display: flex;
    flex-wrap: wrap;
}

.result-title {
    font-size: 16px;
    font-weight: 600;
}

.result-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 12px;
}

.result-box {
    border: 1px solid #e7e7e7;
    border-radius: 4px;
    padding: 12px;
    background: #fafafa;
}

.result-label {
    color: #626262;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.result-value {
    margin-top: 6px;
    word-break: break-word;
}

.result-pre {
    max-height: 360px;
    overflow: auto;
    border: 1px solid #e7e7e7;
    border-radius: 4px;
    padding: 12px;
    background: #fafafa;
    color: #2c2c2c;
    white-space: pre-wrap;
    word-break: break-word;
}

.empty-state {
    color: #626262;
}
</style>
